import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiLinks } from '@cutting/app.api-links';
import { DadataService } from '@cutting/main/shared/services/dadata/dadata.service';
import { UserService } from '@cutting/main/shared/services/user.service';
import {
  CuttingClient,
  IDadataAddressResponse,
  IDadataSuggestAddressRequest,
  PlaceAutocompleteRequest,
  PlaceAutocompleteType,
  PlaceQueryAutocompleteResponseData,
  User,
} from 'cloud-shared-lib';
import { BehaviorSubject, Observable, map } from 'rxjs';

export interface IUserResponse {
  managersDTO: User[];
  totalCount: number;
}

@Injectable()
export class ProfileService {
  about: CuttingClient;
  aboutOnChanged: BehaviorSubject<CuttingClient> = new BehaviorSubject(null);

  constructor(private http: HttpClient, private dadataService: DadataService, private userService: UserService) {}

  /**
   * Resolve
   * @param ActivatedRouteSnapshot route
   * @param RouterStateSnapshot state
   * @param route
   * @param state
   * @returns Observable<any> | Promise<any> | any
   */
  resolve(): Observable<CuttingClient> {
    return this.getClientExtended();
  }

  getClientExtended(): Observable<CuttingClient> {
    return this.userService.getClientExtended().pipe(
      map(res => {
        this.about = res;
        this.aboutOnChanged.next(res);
        return res;
      })
    );
  }

  changeLanguage(idClient: number, langCode: string): void {
    const paramsHttp: HttpParams = new HttpParams().set('langCode', langCode);

    this.http.post(`${ApiLinks.client}/${idClient}/change-language`, undefined, { params: paramsHttp }).subscribe();
  }

  getManagers(pageIndex: number, pageSize: number, filterText: string): Observable<IUserResponse> {
    const paramsHttp: HttpParams = new HttpParams()
      .set('pageIndex', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('withMainUser', 'true')
      .set('filterText', filterText);

    return this.http.get<IUserResponse>(ApiLinks.managers, { params: paramsHttp });
  }

  gatDadataAddressSuggestions(query: string, count = 5): Observable<IDadataAddressResponse[]> {
    return this.dadataService.gatAddress({
      query: query,
      count: count,
      locations: [
        {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          country_iso_code: 'RU',
        },
      ],
    } as IDadataSuggestAddressRequest);
  }

  gatGoogleAddressSuggestions(query: string, lang = 'en'): Observable<PlaceQueryAutocompleteResponseData> {
    const reqData = {
      input: query,
      language: lang,
      types: PlaceAutocompleteType.address,
    } as PlaceAutocompleteRequest;

    return this.http.post<PlaceQueryAutocompleteResponseData>(ApiLinks.googlePlaceAutocomplete, reqData);
  }
}
